// const apiUrl = "http://apit.gitwork.cn:8080/api"
const apiUrl = "https://api.gitwork.cn/api"

const url = process.env.NODE_ENV === "development" ?
  // "http://127.0.0.1:8080/api" :
  apiUrl :
  apiUrl

export const prefix = url.replace(/^\/*([^\/]*.*[^\/]*)\/*$/, "$1")
